module.exports = __webpack_public_path__ + "img/support.89970d73.svg";